

















import { defineComponent, toRefs } from '@vue/composition-api';
import DashboardWidget from '../../../../components/DashboardWidget.vue';
import { DashboardWidgetHeaderColor } from '../../../../types/enums/dashboard-widget-header-color';
import { DashboardWidgetValueColor } from '../../../../types/enums/dashboard-widget-value-color';
import { useDocumentHitsData } from '../composables/document-hits-data.composable';
export default defineComponent({
  name: 'HitRateWidget',
  components: {
    DashboardWidget,
  },
  props: {
    showAll: {
      type: Boolean,
    },
  },
  setup(props) {
    const { showAll } = toRefs(props);
    const { isLoading, isSuccess, value, subValue, valueTitle } = useDocumentHitsData(showAll);

    return {
      value,
      subValue,
      valueTitle,
      DashboardWidgetHeaderColor,
      DashboardWidgetValueColor,
      isLoading,
      isSuccess,
    };
  },
});
